import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ActionItem = () => {
  // const { count_info } = useSelector((state) => state.task);

  // const dueCount = parseInt(count_info?.due_count || 0);
  // const overdueCount = parseInt(count_info?.overdue_count || 0);
  // const reassignedCount = parseInt(count_info?.reassigned_count || 0);
  // const revCount = parseInt(count_info?.rev_count || 0);

  return (
    <div className="dropdown-section">
      <Link to="/actionitems" className="dropdown-item">
        Action Items
        {/* <span className="counter red">{dueCount + overdueCount}</span>
        <span className="counter blue">{reassignedCount + revCount}</span> */}
      </Link>
    </div>
  );
};

export default ActionItem;
